import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ENV } from 'evcharging/app';
import useI18n from "evcharging/hooks/useI18n";
import { PageLink } from "components/common/atoms";

interface PrivacyContentProps {
  title: string;
  listItems: string[];
  image: string;
  reverse?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  image: {
    margin: '118px auto 0',
    [theme.breakpoints.down('xs')]: {
      margin: '108px auto 0',
    },
  },
  title: {
    marginTop: 23,
    textAlign: 'center',
    fontSize: 32,
    fontWeight: 700,
    lineHeight: '36px',
    color: theme.palette.primary.main,
  },
  blockDescription: {
    justifyContent: 'center',
  },
  description: {
    marginTop: 16,
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '32px',
    color: theme.palette.text.primary,
    width: ({ reverse }: PrivacyContentProps) => (reverse ? '880px !important' : 'auto'),
    [theme.breakpoints.up('sm')]: {
      width: ({ reverse }: PrivacyContentProps) => (reverse ? 'auto' : 'auto'),
    },
  },
  link: {
    marginTop: 48,
    marginBottom: 48,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 200,
    lineHeight: '24px',
    color: theme.palette.text.primary,
  },
}));

const FormBuilder: FC<PrivacyContentProps> = (props) => {
  const { title, listItems, image, reverse = false } = props;
  const { t } = useI18n();
  const styles = useStyles(props);
  const mailTo = ENV.CONTACT_EMAIL_TO;
  return (
    <Container>
      <Grid container>
        <Grid className={styles.image} item>
          <img src={image} alt={title} loading="lazy" />
        </Grid>
      </Grid>
      <Typography className={styles.title}>
        <span style={{ color: '#333' }}>{t('document')} </span>
        {title}
      </Typography>
      <Grid className={styles.blockDescription} container>
        {listItems.map((item) => (
          <Typography key={item} className={styles.description}>
            {item}
          </Typography>
        ))}
        {reverse ? (
          <Typography className={styles.description}>
            {t('document.text1')} <a href={`mailto:${mailTo}`}> {mailTo}</a>. {t('document.text2')}
          </Typography>
        ) : (
          <div style={{ display: 'none' }} />
        )}
      </Grid>
      <Grid className={styles.blockDescription} container>
        <Typography className={styles.description}>{t('document.sincerely')}</Typography>
      </Grid>
      <Typography className={styles.link}>
        {t('document.start-from')}&nbsp;
        <PageLink style={{ textDecoration: 'underline' }} href="/">{t('document.home-page')}</PageLink>
      </Typography>
    </Container>
  );
};

export default FormBuilder;
